module.exports = __webpack_public_path__ + "nc_static/media/service-contract-management.1cd76de6.svg";